import store from '@/store'

const consignmentFirstTab = (store.getters.currentUserRole === 'admin'
  || store.getters.currentUserRole === 'director'
  || store.getters.currentUserRole === 'production-master'
  || store.getters.currentUserRole === 'production-manager') ? { name: 'QueueConsignmentList' } : { name: 'ConsignmentListItem' }

export default consignmentFirstTab
